import { render } from "./day-three-afternoon.vue?vue&type=template&id=16e8b2c6"
import script from "./day-three-afternoon.vue?vue&type=script&lang=js"
export * from "./day-three-afternoon.vue?vue&type=script&lang=js"
script.render = render

export default script